module.exports = __webpack_public_path__ + "assets/img/vulnerability-show-more-btn.45e92b0f.svg";